import globalErrorUtils from '../globalErrorUtils';
import { graphQLClient } from '../../utils/graphql';

const post = (query, variables?) => {
    return graphQLClient
        .request(query, variables)
        .then((resp: any) => {
            // return Response.createSuccessful(resp.data, resp.status);
            return resp;
        })
        .catch((error: any) => {
            globalErrorUtils.handleError(error);
            throw error;
        });
};

const graphqlApi = { post };

export default graphqlApi;
